import { request } from "../../api";

export interface GitHubAppConfig {
  configured: boolean;
  name?: string;
  slug?: string;
  owner?: string;
  url?: string;
}

export interface GitHubRegistration {
  action: string;
  manifest: Record<string, unknown>;
}

export const githubAdminApi = {
  config: () => request<GitHubAppConfig>("/v1/admin/github"),
  register: (organization: string) => request<GitHubRegistration>("/v1/admin/github/register", { method: "POST", body: { organization } }),
};

export const githubAdminKeys = { config: ["admin", "github"] as const };
